<template>
  <div class="sessions">
    <ag-table
      :data-source-api="getAllSessionVolunteers"
      :grid-options="gridOptions"
      :permissions="permissions"
      :is-entities-response="false"
      :rtl="false"
    />
  </div>
</template>

<script>
import { RepositoryFactory } from "../volunteer-repositories/volunteerRepositoryFactory";
import AgTable from "@/app/shared/shared-components/ag-grid/AgTableServerSide.vue";
import utilities from "@/app/shared/utilities/index";

const tasksRepo = RepositoryFactory.get("tasksRepository");

export default {
  name: "TaskSessionsManagement",
  components: {
    AgTable,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      status: {
        ACTIVE: "نشطة",
        CANCELLED: "ملغية",
        COMPLETED: "مكتملة",
      },
      permissions: {
        edit: "tasks_management",
        delete: "tasks_management",
        "view-users": "volunteer_manage",
      },
      taskVolunteersIsApplied: {
        'true': 'نعم',
        'false': 'لا',
      },
      taskVolunteersIsCouponApplied: {
        'true': 'نعم',
        'false': 'لا',
      },
    };
  },
  methods: {
    createColDefs() {
      const self = this;
      return [
        {
          headerName: "معرف المتطوع",
          field: "volunteer.id",
          sortable: false,
          width: 200,
        },
        {
          headerName: "الاسم",
          field: "volunteer.name",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
        {
          headerName: "رقم البطاقة",
          field: "volunteer.cardNumber",
          filter: "agTextColumnFilter",
          width: 200,
          sortable: false,
        },
        {
          headerName: "رقم الموبايل",
          field: "volunteer.phoneNumber",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
        {
          headerName: "تم القبول من المتطوع",
          field: "isConfirmed",
          width: 210,
          sortable: false,
          valueGetter: function getObject(data) {
            return data.data.isConfirmed ? "نعم" : "لا";
          },
          filter: 'agSetColumnFilter',
          filterParams: {
            values: Object.keys(self.taskVolunteersIsApplied),
            valueFormatter: params => {
              return self.taskVolunteersIsApplied[params.value];
            }
          }
        },
        {
          headerName: "تم تطبيق الكوبون",
          field: "isCouponApplied",
          width: 210,
          sortable: false,
          valueGetter: function getObject(data) {
            return data.data.isCouponApplied ? "نعم" : "لا";
          },
          filter: 'agSetColumnFilter',
          filterParams: {
            values: Object.keys(self.taskVolunteersIsCouponApplied),
            valueFormatter: params => {
              return self.taskVolunteersIsCouponApplied[params.value];
            }
          }
        },
        {
          headerName: "عنوان الفرصة",
          field: "taskSession.task.title",
          width: 200,
        },
        {
          headerName: "تاريخ التقديم",
          field: "taskSession.appliedAt",
          filter: "agDateColumnFilter",
          width: 200,
          valueGetter: function getObject(data) {
            return data.data.taskSession.appliedAt ? utilities.formatDate(data.data.taskSession.appliedAt, "yyyy-MM-DD") : '-';
          },
        },
        {
          headerName: "التاريخ",
          field: "taskSession.date",
          filter: "agDateColumnFilter",
          width: 200,
          valueGetter: function getObject(data) {
            return data.data.taskSession.date ? utilities.formatDate(data.data.taskSession.date, "yyyy-MM-DD") : '-';
          },
        },
        {
          headerName: "من وقت",
          field: "taskSession.startAt",
          width: 200,
          valueGetter: function getObject(data) {
            return data.data.taskSession.startAt || '-';
          },
        },
        {
          headerName: "إلى وقت",
          field: "taskSession.endAt",
          width: 200,
          valueGetter: function getObject(data) {
            return data.data.taskSession.endAt || '-';
          },
        },
        {
          headerName: "حالة الجلسة",
          field: "taskSession.status",
          width: 200,
          filter: 'agSetColumnFilter',
          filterParams: {
            values: self.status ? Object.keys(self.status) : [],
            valueFormatter: params => self.status[params.value] || params.value,
          },
          valueGetter: function getObject(params) {
            return self.status[params.data.taskSession.status] || "-";
          },
        },
      ];
    },
    async getAllSessionVolunteers(query) {
      return await tasksRepo.fetchTaskSessionAppliedVolunteers(this.$route.params.sessionId, query);
    },
  },
  created() {
    this.gridOptions = {};
    if (this.gridOptions) {
      this.gridOptions.columnDefs = this.createColDefs();
    }
  },
  mounted() {
    if (this.gridOptions) {
      this.gridApi = this.gridOptions.api;
    }
  },
};
</script>
